import { VueEditor } from "vue3-editor"

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.component("vue-editor", VueEditor)
})
